/**
 * ModeSwitchDialog - Confirmation when switching between mutually exclusive modes
 */
import { Button } from '../../components/ui/button';
import {
    Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription
} from '../../components/ui/dialog';

export const ModeSwitchDialog = ({
    open, onOpenChange, pendingMode, t,
    onConfirm, onCancel
}) => (
    <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-md">
            <DialogHeader>
                <DialogTitle>
                    {pendingMode === 'review_shield'
                        ? t('reviewShield.switchToShieldTitle', 'Switch to Review Shield?')
                        : t('reviewShield.switchToAdTitle', 'Switch to Landing Page?')
                    }
                </DialogTitle>
                <DialogDescription>
                    {pendingMode === 'review_shield'
                        ? t('reviewShield.switchToShieldMessage', 'Review Shield cannot run at the same time as the Landing Page (Advertising). Turning on Review Shield will automatically turn OFF the Landing Page.')
                        : t('reviewShield.switchToAdMessage', 'Landing Page (Advertising) cannot run at the same time as Review Shield. Turning on the Landing Page will automatically turn OFF Review Shield.')
                    }
                </DialogDescription>
            </DialogHeader>
            <DialogFooter>
                <Button variant="outline" onClick={onCancel}>
                    {t('common.cancel', 'Cancel')}
                </Button>
                <Button onClick={onConfirm} data-testid="confirm-mode-switch-btn">
                    {t('reviewShield.continue', 'Continue')}
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
);
